import React, { useCallback, useState } from "react";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { VERDE } from "../components/SaudeAnunciosML/comum";
import PainelTab from "../components/MetricasAnuncios/PainelTab";
import AnunciosTab from "../components/MetricasAnuncios/AnunciosTab";
import ExperimentoTab from "../components/MetricasAnuncios/ExperimentoTab";
import TrocasTab from "../components/MetricasAnuncios/TrocasTab";
import DetalheAnuncio from "../components/MetricasAnuncios/DetalheAnuncio";

const CHAVE_ABA = "metricas_anuncios_aba";
const ABAS = [
  { curto: "Visão geral", longo: "Visão geral" },
  { curto: "Anúncios", longo: "Anúncios" },
  { curto: "Premium x Clássico", longo: "Premium x Clássico" },
  { curto: "Trocas", longo: "Trocas de tipo" },
];

const lerAba = () => {
  try {
    const n = Number(window.localStorage.getItem(CHAVE_ABA));
    return Number.isInteger(n) && n >= 0 && n < ABAS.length ? n : 0;
  } catch (e) {
    return 0;
  }
};

export default function MetricasAnuncios() {
  const [aba, setAba] = useState(lerAba);
  const [aberto, setAberto] = useState(null);

  const mudarAba = useCallback((i) => {
    setAba(i);
    try {
      window.localStorage.setItem(CHAVE_ABA, String(i));
    } catch (e) {
      return;
    }
  }, []);

  return (
    <Box ml={{ base: 0, md: "64px" }} pt="70px" px={{ base: 3, md: 6 }} pb={10} minH="100vh" bg="gray.50">
      <Text as="h1" fontSize="2xl" fontWeight="bold" color={VERDE} lineHeight="short" mb={3}>Métricas de Anúncios</Text>

      <Box bg="white" borderRadius="lg" boxShadow="sm">
        <Tabs colorScheme="orange" index={aba} onChange={mudarAba} isLazy>
          <TabList px={{ base: 1, md: 4 }} overflowX="auto" overflowY="hidden" whiteSpace="nowrap"
            sx={{ scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
            {ABAS.map(({ curto, longo }) => (
              <Tab key={longo} aria-label={longo} fontWeight="bold" fontSize="sm" flexShrink={0} minH="44px" px={{ base: 3, md: 4 }}>
                {curto === longo ? longo : (
                  <>
                    <Box as="span" display={{ base: "inline", md: "none" }}>{curto}</Box>
                    <Box as="span" display={{ base: "none", md: "inline" }}>{longo}</Box>
                  </>
                )}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            <TabPanel p={0}><PainelTab onAbrir={setAberto} /></TabPanel>
            <TabPanel p={0}><AnunciosTab onAbrir={setAberto} /></TabPanel>
            <TabPanel p={0}><ExperimentoTab /></TabPanel>
            <TabPanel p={0}><TrocasTab onAbrir={setAberto} /></TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

      <DetalheAnuncio idMl={aberto} onFechar={() => setAberto(null)} />
    </Box>
  );
}
